export type OnboardingStepId = 1 | 2 | 3;

export type OnboardingBirthFormForValidation = {
  readonly name: string;
  readonly birthDate: string;
  readonly birthPlace: string;
  readonly city: unknown | null;
};

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function isOnboardingStepValid(
  step: OnboardingStepId,
  form: OnboardingBirthFormForValidation,
): boolean {
  if (step === 1) return true;
  if (step === 2) {
    return (
      form.name.trim().length > 0 &&
      DATE_PATTERN.test(form.birthDate) &&
      form.birthPlace.trim().length > 0 &&
      form.city !== null
    );
  }
  return true;
}
